class TfTab extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll("[data-tab]");
    this.panels = this.querySelectorAll("[data-panel]");

    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.switchTab(button.dataset.tab);
      });
    });
  }

  switchTab(tabId) {

    this.buttons.forEach((btn) => {
      btn.classList.remove("active");
    });

    this.panels.forEach((panel) => {
      panel.classList.remove("active");
    });

    const activeButton = this.querySelector(`[data-tab="${tabId}"]`);
    const activePanel = this.querySelector(`[data-panel="${tabId}"]`);

    if (activeButton) activeButton.classList.add("active");
    if (activePanel) activePanel.classList.add("active");
  }
}

customElements.define("tf-tab", TfTab);